import { IGridColumn } from './IColumn.interface';
import { IGridEditing } from './IGridEditing.interface';

export interface IDataGrid {
    columns: IGridColumn[];
    dataSource: object[];
    allowSearch: boolean;
    allowSelection: boolean;
    gridEditing: IGridEditing;
}
